var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-wrapper auth-v2" },
    [
      _c(
        "b-row",
        { staticClass: "auth-inner m-0" },
        [
          _c("b-link", { staticClass: "brand-logo main__logo__title" }, [
            _c("img", {
              attrs: {
                src: require("../../assets/images/logo/logo.svg"),
                alt: "",
              },
            }),
            _c("h2", { staticClass: "brand-text ml-1 title" }, [
              _vm._v(" Enterprise"),
              _c("br"),
              _c("span", { staticClass: "title_go" }, [_vm._v("GoDigital")]),
            ]),
          ]),
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-flex align-items-center p-5",
              attrs: { lg: "8" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "w-100 d-lg-flex align-items-center justify-content-center px-5",
                },
                [
                  _c("b-img", {
                    attrs: {
                      fluid: "",
                      src: _vm.imgUrl,
                      alt: "Forgot password V2",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center auth-bg px-2 p-lg-5",
              attrs: { lg: "4" },
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 mx-auto",
                  attrs: { sm: "8", md: "6", lg: "12" },
                },
                [
                  _c("b-card-title", { staticClass: "mb-1" }, [
                    _vm._v(" Please Verify Your Email 🔒 "),
                  ]),
                  _c("b-card-text", { staticClass: "mb-2" }, [
                    _vm._v(
                      " We have sent a One-Time Password (OTP) to your email address. Please enter the OTP below to verify your identity. "
                    ),
                  ]),
                  _c(
                    "validation-observer",
                    { ref: "simpleRules" },
                    [
                      _c(
                        "b-form",
                        {
                          staticClass: "auth-forgot-password-form mt-2",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.validationForm($event)
                            },
                          },
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: { label: "Enter OTP", "label-for": "otp" },
                            },
                            [
                              _c("validation-provider", {
                                attrs: { name: "OTP", rules: _vm.otpRules },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            state:
                                              errors.length > 0 ? false : null,
                                            placeholder: "Enter 6 digit OTP",
                                            maxlength: "6",
                                          },
                                          model: {
                                            value: _vm.otp,
                                            callback: function ($$v) {
                                              _vm.otp = $$v
                                            },
                                            expression: "otp",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getErrorMessage(errors[0])
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary",
                                block: "",
                                to: { name: "newpassword" },
                              },
                            },
                            [_vm._v(" Verify OTP ")]
                          ),
                          _vm.countdown > 0
                            ? _c("p", { staticClass: "text-center my-2" }, [
                                _vm._v(
                                  " Resend OTP in " +
                                    _vm._s(_vm.countdown) +
                                    " seconds "
                                ),
                              ])
                            : _c(
                                "p",
                                {
                                  staticClass: "text-start my-2 font-bold",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { to: { name: "newpassword" } },
                                  on: { click: _vm.resendOTP },
                                },
                                [_vm._v(" Resend OTP ")]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "text-center mt-2",
                      on: { click: _vm.logout },
                    },
                    [
                      _c(
                        "b-link",
                        [
                          _c("feather-icon", {
                            attrs: { icon: "ChevronLeftIcon" },
                          }),
                          _vm._v(" Back to login "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }